import { Stack, Heading, Text, Box } from "@chakra-ui/layout";
import { useColorModeValue } from "@chakra-ui/color-mode";
import { layerStyle, radius, textStyle } from "theme/names";

interface Props {
  title?: string;
  description?: string;
  children: React.ReactNode;
  css?: any;
}

export function CustomSection({ title, description, children, css = {} }: Props) {
  return (
    <Box
      p={[4, 8]}
      layerStyle={layerStyle["bg.border.rounded"]}
      borderRadius={radius.lg}
      overflow="auto"
    >
      <Stack {...css}>
        {title && <Text textStyle={textStyle["h3.bold.standard"]}>
          {title}
        </Text>}
        {description && (
          <Text textStyle={textStyle["body.medium.light"]} maxW="600px">
            {description}
          </Text>
        )}
        {children}
      </Stack>
    </Box>
  );
}
